import GATSBY_COMPILED_MDX from "/opt/build/repo/content/pages/nouvelles/index.mdx";
import {useEffect, useState} from 'react';
import {graphql} from 'gatsby';
import {MDXProvider} from '@mdx-js/react';
import {useTheme} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {IconContext} from '@phosphor-icons/react';
import TopAppBar from '@/components/_layout/AppBar/TopAppBar';
import TopAppBarSm from '@/components/_layout/AppBar/TopAppBarSm';
import {QuickLinks, QuickLinksSm} from '@/components/_layout/QuickLinks';
import Footer from '@/components/_layout/Footer/Footer';
import Breadcrumbs from '@/components/_layout/Breadcrumbs/Breadcrumbs';
import SEO from '@/components/_layout/SEO';
import Debug from '@/components/_layout/Debug';
import LayoutGrid from '../components/utils/LayoutGrid';
import RetroactionUsager from '@/components/RetroactionUsager';
import {useSmall} from '@/hooks/use-small';
import {SecondaryNav} from '@/components/_layout/SecondaryNav/SecondaryNav';
import {getLastSundayISODate} from '@/utils/dateTimeUtils';
import commonComponents from './commonComponents';
function getCurrentPageLevel(location) {
  return location.pathname.split('/').filter(item => item).length;
}
function PageTemplate({pageContext, children, data, location}) {
  const isSmall = useSmall('md');
  const isMedium = useSmall('lg');
  const theme = useTheme();
  const [hasSecondaryNav, setHasSecondaryNav] = useState(false);
  const [lvl, setLvl] = useState(getCurrentPageLevel(location));
  useEffect(() => {
    setLvl(getCurrentPageLevel(location));
  }, [location]);
  useEffect(() => {
    setHasSecondaryNav(lvl > 1);
  }, [lvl]);
  if (typeof window !== 'undefined') {
    window.bib = window.bib || ({});
    window.bib.theme = theme;
    console.log('window.bib.theme:', window.bib.theme);
  }
  const {breadcrumb: {crumbs}} = pageContext;
  const mainContent = React.createElement(React.Fragment, null, hasSecondaryNav && React.createElement(Breadcrumbs, {
    crumbs: crumbs
  }), React.createElement("main", {
    role: "main"
  }, children, React.createElement(RetroactionUsager)));
  return React.createElement(MDXProvider, {
    components: commonComponents
  }, React.createElement(IconContext.Provider, {
    value: {
      size: '2rem',
      color: theme.palette.grey['700']
    }
  }, process.env.NODE_ENV !== 'production' && React.createElement(Debug), React.createElement("div", {
    style: {
      position: 'absolute',
      background: '#fff',
      top: 0,
      right: 0,
      padding: '.5em'
    }
  }, lvl), React.createElement("udem-urgence"), isMedium ? React.createElement(TopAppBarSm) : React.createElement(TopAppBar, {
    lvl: lvl,
    location: location
  }), isSmall ? React.createElement(QuickLinksSm) : React.createElement(QuickLinks), hasSecondaryNav ? React.createElement(LayoutGrid, {
    outter: true
  }, React.createElement(Grid, {
    container: true,
    spacing: {
      xs: 1,
      sm: 3,
      lg: 4
    }
  }, React.createElement(Grid, {
    size: 3
  }, React.createElement(SecondaryNav, {
    currentLocation: location
  })), React.createElement(Grid, {
    size: 9
  }, mainContent))) : React.createElement(React.Fragment, null, mainContent), React.createElement(Footer)));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
  query ($id: String!) {
    mdx(id: { eq: $id }) {
      frontmatter {
        title
      }
    }
  }
`;
export function Head({pageContext, location}) {
  const {frontmatter} = pageContext;
  const {pathname} = location;
  return React.createElement(React.Fragment, null, React.createElement("html", {
    lang: "fr-CA"
  }), React.createElement(SEO, {
    title: frontmatter?.title,
    pathname: pathname
  }), React.createElement("bib-gtm"), ['/espaces', 'nous-joindre'].some(path => pathname.startsWith(path)) && React.createElement(React.Fragment, null, React.createElement("link", {
    rel: "preload",
    href: "https://api.bib.umontreal.ca/horaires/services",
    as: "fetch",
    crossorigin: "anonymous"
  }), React.createElement("link", {
    rel: "preload",
    href: `https://api.bib.umontreal.ca/horaires/?debut=${getLastSundayISODate()}&fin=P7D`,
    as: "fetch",
    crossorigin: "anonymous"
  })), React.createElement("script", {
    type: "module",
    src: "https://cdn.jsdelivr.net/gh/bibudem/ui@0/dist/bib-gtm.js"
  }), React.createElement("script", {
    type: "module",
    src: "https://cdn.jsdelivr.net/gh/bibudem/ui@0/dist/bib-retroaction-usager.js"
  }), React.createElement("script", {
    type: "module",
    src: "https://cdn.jsdelivr.net/gh/bibudem/ui@0/dist/udem-urgence.js"
  }), React.createElement("script", {
    type: "module",
    src: "https://cdn.jsdelivr.net/gh/bibudem/ui@0/dist/bib-consent.js"
  }), React.createElement("script", {
    type: "module",
    src: "https://cdn.jsdelivr.net/gh/bibudem/ui@0/dist/bib-consent-preferences-btn.js"
  }));
}
